import Currency from './currency'

import React, { useState } from 'react'

const Leaderboard = ctx => {
  const [truncated, setTruncated] = useState(ctx.leaderBoard.length > 15)

  function leaderBoardTruncated() {
    return ctx.leaderBoard.length < ctx.totalParticipants
  }

  function leaderboardDisplayItems() {
    return truncated ? ctx.leaderBoard.slice(0,15) : ctx.leaderBoard
  }

  function toggleShowAll(e) {
    e.preventDefault()
    setTruncated(!truncated)
  }

  return <div className="panel">
    <h2 className="panel-heading">Leaderboard{ leaderBoardTruncated() ? `: Top ${ctx.leaderBoard.length}` : ''}</h2>
    <ul>
    { leaderboardDisplayItems().map((l, i) => {
    return <li key={`l-${l.name}-${i}`} className="columns is-mobile panel-block">
        <div className="column">{ l.name}</div>
        <div className="column"><span className="is-pulled-right"><Currency bettingCurrencySymbol={ctx.bettingCurrencySymbol} amount={l.balance} /></span></div>
      </li>
    })}
  { truncated ?  <li className="columns is-mobile panel-block">
      <div className="column"><a href="#" onClick={toggleShowAll}>Show more</a></div>
      </li>
   :  leaderBoardTruncated()  ? <li className="columns is-mobile panel-block">
          <div className="column">...</div>
       </li> : null}
    </ul>
  </div>
}

export default Leaderboard
